import { SlotGameType1_2 } from "../SlotGameType1_2";
export class IceBlast2 extends SlotGameType1_2{}

